import { Fancybox } from "@fancyapps/ui";
import Faqs from "../../../frontend/blocks/faqs/faqs.js";
import HeaderScroll from "./components/HeaderScroll.js";
import Carousel from "./components/Carousel.js";
import MobileMenu from "./components/MobileMenu.js";
import Toggle from "./components/Toggle.js";
import FooterToggle from "./components/FooterToggle.js";
import Tabs from "./components/Tabs.js";
import GformUpload from "./components/GformUpload.js";
import SmoothScroll from "./components/SmoothScroll.js";
import NumberCounter from "./components/NumberCounter.js";
import ImageGalleryVideoSlider from "../../../frontend/blocks/image-gallery-video/image-gallery-video";
import "../../../node_modules/vanilla-cookieconsent/dist/cookieconsent.js";
import MediaTextarea from "../../../frontend/blocks/media-textarea/media-textarea";
import Testimonials from '../../../frontend/blocks/testimonials/testimonials.js';
import FlickityMatchHeight from './components/FlickityMatchHeight.js';
import MediaColumnsSlider from '../../../frontend/blocks/media-columns/media-columns';
import FormBlock from "../../../frontend/blocks/form-block/form-block.js";
import PracticeAreaCard from "./components/PracticeAreaCard.js";
import GoogleMap from '../../../frontend/blocks/google-map/google-map.js';
import PageOverlay from "./components/PageOverlay.js";
import CategorySelect from "./components/CategorySelect.js";
import { SearchClear } from "./components/SearchClear.js";
import TeamCards from "./components/TeamCards.js";
import LangSwitcher from "./components/LangSwitcher.js";
import aos from "aos";;
import Animate from "./components/Animate.js";
import CookieControl from "./components/CookieControl.js";
import ImageSlide from "./components/ImageSlide.js";


Animate();

aos.init({
    // mirror: true, // Elements will animate out (reverse animation) when scrolling past them
  });

CookieControl();

LangSwitcher();

PageOverlay();

{
    const teamCards = document.querySelector('.team-cards');
    if (typeof teamCards !== "undefined" && teamCards !== null) {
        TeamCards(teamCards);
    }
}

{
    const searchClear = document.querySelector('.search-form__field');
    if (typeof searchClear !== "undefined" && searchClear !== null) {
        SearchClear(searchClear);
    }
}

{

    const googleMap = document.querySelector('[data-google-map]');
    if (typeof googleMap != "undefined" && googleMap != null) {
        GoogleMap();
    }
}


{
    // Load the match height fix for Flickiy slides
    FlickityMatchHeight();
}

{
    const categorySelect = document.querySelector(".blog-archive__nav-wrap");

    if (typeof categorySelect != "undefined" && categorySelect != null) {
        CategorySelect(categorySelect);
    }
}

{
    const PracticeAreaCard = document.querySelector(".practice-area-card");

    if (typeof practiceAreaCard != "undefined" && practiceAreaCard != null) {
        PracticeAreaCard(practiceAreaCard);
    }
}

{
    const numberCounter = document.querySelector(".js-count-up");
    if (typeof numberCounter != "undefined" && numberCounter != null) {
        NumberCounter();
    }
}

{
    const slider = document.querySelector(".carousel");

    if (typeof slider != "undefined" && slider) {
        Carousel();
    }
}

{
    const formBlock = document.querySelector(".form-block");

    if (typeof formBlock != "undefined" && formBlock) {
        FormBlock();
    }
}

{
    const header = document.querySelector(".header");

    if (typeof header != "undefined" && header) {
        HeaderScroll();
    }
}

{
    const faqs = document.querySelector("[data-question]");

    if (typeof faqs != "undefined" && faqs) {
        Faqs();
    }
}

{
    const mobile_menu = document.querySelector(".mobile-menu");

    if (typeof mobile_menu != "undefined" && mobile_menu) {
        MobileMenu();
    }
}

{
    const toggle_element = document.querySelector("[data-toggle]");

    if (typeof toggle_element != "undefined" && toggle_element) {
        Toggle();
    }
}

{
    const footer_toggle = document.querySelector("[data-footer-toggle]");

    if (typeof footer_toggle != "undefined" && footer_toggle) {
        FooterToggle();
    }
}

{
    const tabs = document.querySelector("[data-tabs]");

    if (typeof tabs != "undefined" && tabs != null) {
        Tabs();
    }
}

{
    if (typeof gform != "undefined" && gform != null) {
        GformUpload();
    }
}

{
    const anchorLink = document.querySelector("[data-smooth-scroll]");

    if (typeof anchorLink != "undefined" && anchorLink != null) {
        SmoothScroll(anchorLink);
    }
}

{
    const imageGalleryVideoSlider = document.querySelector(
        ".image-gallery-video__images--slider"
    );

    if (
        typeof imageGalleryVideoSlider != "undefined" &&
        imageGalleryVideoSlider != null
    ) {
        ImageGalleryVideoSlider(imageGalleryVideoSlider);
    }
}

{
    const testimonials = document.querySelector('[data-testimonials]');
    if (typeof testimonials != "undefined" && testimonials != null) {
        Testimonials(testimonials);
    }
}

{
    const iconColumnsSlides = document.querySelector('[data-icon-columns]');

    if (typeof iconColumnsSlides  != "undefined" && iconColumnsSlides  != null) {
        IconColumnsSlider(iconColumnsSlides);
    }
}

{
    const mediaTextarea = document.querySelector(".media-textarea__slider");

    if (typeof mediaTextarea != "undefined" && mediaTextarea != null) {
        MediaTextarea();
    }
}

{
    const mediaColumnsSlider = document.querySelector('[data-media-columns]');

    if (typeof mediaColumnsSlider  != "undefined" && mediaColumnsSlider  != null) {
        MediaColumnsSlider(mediaColumnsSlider);
    }
}

{
    const imagesToWipe = document.querySelectorAll('.image-wipe');

    if (typeof imagesToWipe != "undefined" && imagesToWipe != null) {
        ImageSlide();
    }
}
